export default __webpack_public_path__ + "static/media/3.178933b4.png";